/**
 * 统计事件 ID 汇总
 *
 * 《埋点数据字典》，可复制链接后用石墨文档 App 或小程序打开
 *
 * @link https://shimo.im/docs/GPdgj8vdrWYJttyT/
 */
export const eventIdMap = {
  // =====================================================
  // CET4 2021
  // @link https://shimo.im/sheets/gXqmeQnx64HyNZqo/MODOC
  CET4_HOME_VISIT: 'activity_homepage_visit',
  CET4_HOME_APPLY_CLICK: 'activity_register_click',
  CET4_HOME_SKILL_CARD_CLICK: 'activity_content_click',
  CET4_HOME_SKILL_MORE_CLICK: 'activity_content_more_click',
  CET4_HOME_SIGN_CLICK: 'activity_sign_click',
  CET4_HOME_RECITE_CLICK: 'activity_word_click',
  CET4_HOME_PLAN_MATERIAL_CLICK: 'activity_material_click',
  CET4_HOME_SHARE_CLICK: 'activity_share_click',
  CET4_HOME_SHARE_RESULT_CLICK: 'activity_share_result_click',
  CET4_HOME_PLAN_ALL_MATERIAL_CLICK: 'activity_allmaterial_click',
  CET4_HOME_PREVIEW_CLICK: 'activity_notices_click',
  CET4_DETAIL_SKILL_CARD_CLICK: 'activity_any_content_click',
  CET4_POSTER_VISIT: 'share_page_visit',
  CET4_POSTER_GOTO_BCZ_CLICK: 'share_go_bcz_click',
  // =====================================================

  // =====================================================
  // Term Begins 2022
  // @link https://shimo.im/sheets/QWYJHtDR6kVrQJYk/MODOC
  // =====================================================
  TERM_BEGINS_2021_PRESENT_PAGE_VISIT: 'main_page_visit',

  TERM_BEGINS_2021_WARMUP_PAGE_VISIT: 'activity_preview_visit',
  TERM_BEGINS_2021_WARMUP_APPLY_CLICK: 'sign_up_click',

  TERM_BEGINS_2021_SHARING_PAGE_VISIT: 'share_page_visit',
  TERM_BEGINS_2021_SHARING_DOWNLOAD_CLICK: 'bcz_visit_click',

  TERM_BEGINS_2021_BINGO3_CLICK: 'exam_package_visit',
  TERM_BEGINS_2021_BINGO5_CLICK: 'exam_map_visit',

  TERM_BEGINS_2021_LOTTERY_DRAW_CLICK: 'luck_draw_click',
  // =====================================================
}
